var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCncGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1142 4089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.789,269.035l.411,2.229-.061-.065a1.032,1.032,0,0,0,.369,2.03l.021.1,1.234,7.267-1.151.659H251v1.156l-.041-.082a4.657,4.657,0,0,0-4.647,4.666l.083.04H233.647v-.04A4.656,4.656,0,0,0,229,282.329l.041.082v-1.156h8.471l-1.151-.659,1.234-7.267-.062-.1a1.032,1.032,0,0,0,.37-2.03l.021.065.411-2.229h.987",
    transform: "translate(914 -4355)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.789,269.035l.411,2.229-.061-.065a1.032,1.032,0,0,0,.369,2.03l.021.1,1.234,7.267-1.151.659H251v1.156l-.041-.082a4.657,4.657,0,0,0-4.647,4.666l.083.04H233.647v-.04A4.656,4.656,0,0,0,229,282.329l.041.082v-1.156h8.471l-1.151-.659,1.234-7.267-.062-.1a1.032,1.032,0,0,0,.37-2.03l.021.065.411-2.229h.987",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1142 -4089)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCncGrey);
export default __webpack_public_path__ + "static/media/cnc_grey.53d6e610dfa95e1ac5b896cbdeb11272.svg";
export { ForwardRef as ReactComponent };